import { LegalClientActivity } from 'api/types/entity';
import { isYes, yesOrNotSelectValidation } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  mixed,
} from 'libs/form';
import { Maybe } from 'types/maybe';
import { SelectType } from 'types/selectType';
import { YesOrNoSelectType } from 'types/yesOrNo';

export interface CompanyActivityFormType {
  companyActivity: {
    activity: SelectType<LegalClientActivity>;
    otherActivity?: string;
    isLargeEnterprise: Maybe<YesOrNoSelectType>;
    isNominalHolder: Maybe<YesOrNoSelectType>;
    requiresNominalHoldingSubaccount: Maybe<YesOrNoSelectType>;
  };
}

const isOtherActivity = (activity: SelectType<LegalClientActivity>) =>
  activity?.value === LegalClientActivity.Other;

export const getCompanyActivitySchema =
  (): ObjectSchema<CompanyActivityFormType> =>
    object({
      companyActivity: object({
        activity: object({
          value: mixed<LegalClientActivity>()
            .oneOf(Object.values(LegalClientActivity))
            .required(),
          label: string().required(),
        })
          .default(null)
          .required(),
        otherActivity: string().when('activity', {
          is: isOtherActivity,
          then: (schema) => schema.required().max(200),
        }),
        isLargeEnterprise: yesOrNotSelectValidation.default(null).required(),
        isNominalHolder: yesOrNotSelectValidation.default(null).required(),
        requiresNominalHoldingSubaccount: yesOrNotSelectValidation
          .default(undefined)
          .nullable()
          .when('isNominalHolder', {
            is: isYes,
            then: (schema) => schema.default(null).required(),
          }),
      }),
    });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<CompanyActivityFormType>();

export type FormErrors = FormErrorsBase<CompanyActivityFormType>;
